import { Button, Grid, Icon, Stack } from "@mui/material";
import moment from "moment";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { CalendarMonth as CalendarMonthIcon } from "@mui/icons-material";
import TableAction from "components/TableAction";

const ApplicationInterviewListItem = ({
  row,
  idx,
  onEdit,
  parent,
  companyType,
  setInterviewPreview,
  onPressSchedule,
  onPressCancel,
}) => {
  const {
    venueName,
    companyName,
    title,
    jobName,
    eventDate,
    applyDate,
    modifiedDate,
    status,
    isAutoScheduling,
    isAIScreening,
    isAwaitingConfirmation,
  } = row;
  const date = parent === "job" ? applyDate || modifiedDate : eventDate;

  return (
    <>
      <Stack
        display="flex"
        direction="row"
        justifyContent="space-between"
        onClick={() => {
          onEdit?.(idx, row, true);
        }}
        sx={{
          height: "38px",
        }}
      >
        <Grid container display="flex" alignItems="center">
          <Grid item sm={12}>
            <Grid container justifyContent="left" alignItems="center" spacing={1}>
              <Grid item sm={3}>
                <MDTypography sx={{ fontSize: "0.8rem" }}>
                  {companyType === "Venue" ? venueName : companyName}
                </MDTypography>
              </Grid>

              <Grid item sm={3} textAlign="center">
                <MDTypography sx={{ fontSize: "0.8rem" }}>
                  {parent === "job" ? title : jobName}
                </MDTypography>
              </Grid>

              <Grid item sm={3} textAlign="end">
                <MDTypography sx={{ fontSize: "0.8rem" }}>
                  {isAutoScheduling && !isAwaitingConfirmation && "Pending"}
                  {isAutoScheduling && isAwaitingConfirmation && "Awaiting Confirmation"}
                  {!isAutoScheduling && moment(date).format("MM/DD/YYYY")}
                </MDTypography>
              </Grid>

              <Grid item sm={3} textAlign="end">
                {isAutoScheduling && !isAwaitingConfirmation && (
                  <Button
                    type="button"
                    variant="contained"
                    color="success"
                    startIcon={<CalendarMonthIcon />}
                    style={{
                      // backgroundColor: "#8935f4",
                      textTransform: "none",
                      fontSize: "0.9rem",
                      paddingTop: 0,
                      paddingBottom: 0,
                    }}
                    onClick={() => onPressSchedule(row)}
                  >
                    Schedule Now
                  </Button>
                )}
                {(!isAutoScheduling || isAwaitingConfirmation) && (
                  <TableAction
                    color="info"
                    icon="info"
                    clickAction={(e) => {
                      setInterviewPreview(row);
                    }}
                    tooltip={isAIScreening || isAwaitingConfirmation ? "" : "Interview Info"}
                    disabled={isAIScreening || isAwaitingConfirmation}
                  />
                )}
                {(!isAutoScheduling || isAwaitingConfirmation) && (
                  <TableAction
                    color="error"
                    icon="delete"
                    clickAction={(e) => {
                      onPressCancel(row);
                    }}
                    tooltip={
                      isAIScreening ||
                      (row?.eventType !== "Screening Interview" && !isAwaitingConfirmation)
                        ? ""
                        : "Cancel Interview"
                    }
                    disabled={
                      isAIScreening ||
                      (row?.eventType !== "Screening Interview" && !isAwaitingConfirmation)
                    }
                  />
                )}
              </Grid>
              {/* <Grid item sm={3} textAlign="end">
                <MDTypography sx={{ fontSize: "0.8rem" }}>{status}</MDTypography>
              </Grid> */}
            </Grid>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default ApplicationInterviewListItem;
